import {registerMaterialGraphNode} from "#material/register"
import {MaterialNode} from "#material/nodes/base/material/material-node"
import type {AmbientOcclusionSockets} from "#material/nodes/shader/ambient-occlusion/definition"
import {ambientOcclusionDefinition} from "#material/nodes/shader/ambient-occlusion/definition"
import type {CyclesReturns} from "#material/sockets/cycles"
import type {CyclesEvaluator, ThreeEvaluator} from "#material/nodes/base/material/types/evaluators"
import {cyclesColor, cyclesVec3} from "#material/cycles/helpers"
import type {AmbientOcclusionNode} from "#material/cycles/types"
import type {ThreeReturns} from "#material/sockets/three"
import {threeRGBColor, threeValue} from "#material/three/three-utils"

@registerMaterialGraphNode
export class AmbientOcclusion extends MaterialNode<AmbientOcclusionSockets> {
    public override get definition() {
        return ambientOcclusionDefinition
    }

    override toCycles = async (evaluator: CyclesEvaluator): Promise<CyclesReturns<AmbientOcclusionSockets>> => {
        const ambientOcclusionNode: AmbientOcclusionNode = {
            type: "ambient_occlusion",
            inputs: await evaluator.getAll({
                color: this.parameters.inputs.color,
                distance: this.parameters.inputs.distance,
                normal: this.parameters.inputs.normal,
            }),
            parameters: {
                color: cyclesColor(this.parameters.settings.color),
                distance: this.parameters.settings.distance,
                inside: this.parameters.settings.inside,
                normal: cyclesVec3(this.parameters.settings.normal),
                only_local: this.parameters.settings.onlyLocal,
                samples: this.parameters.settings.samples,
            },
            resources: {},
        }

        return {ao: [ambientOcclusionNode, "ao"], color: [ambientOcclusionNode, "color"]}
    }

    override toThree = async (evaluator: ThreeEvaluator): Promise<ThreeReturns<AmbientOcclusionSockets>> => {
        return {
            color: threeRGBColor({r: 0, g: 0, b: 0}),
            ao: threeValue(0),
        }
    }
}
